import { render, staticRenderFns } from "./Riddle.vue?vue&type=template&id=52405aac&scoped=true&"
import script from "./Riddle.vue?vue&type=script&lang=js&"
export * from "./Riddle.vue?vue&type=script&lang=js&"
import style0 from "./Riddle.vue?vue&type=style&index=0&id=52405aac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52405aac",
  null
  
)

export default component.exports